import { Grid, Stack, styled } from '@mui/material';
import { Label, WsColors } from 'wisestep-base';

import { CustomLayoutProps } from '../customFormInputProps';

const StyledStack = styled(Stack)(({ theme }) => ({
  borderColor: WsColors.BorderGrey,
  borderWidth: 2,
  borderRadius: theme.spacing(1),
}));

const FormSwitchLayout = ({
  label,
  children,
  gridValue = 6,
  border = 'solid',
  justifyContent = 'space-between',
}: CustomLayoutProps) => (
  <Grid item lg={gridValue} md={gridValue}>
    <StyledStack
      display="flex"
      direction="row"
      border={border}
      spacing={1}
      justifyContent={justifyContent}
      padding={border === 'none' ? 0 : 1}
    >
      <Label sx={{ fontWeight: 'bold' }}>{label}</Label>
      {children}
    </StyledStack>
  </Grid>
);

export default FormSwitchLayout;
